export enum RetailCodeTableKey {
  A001 = 'A001',
  A002 = 'A002',
  A003 = 'A003',
  A004 = 'A004',
  A005 = 'A005',
  A006 = 'A006',
  A007 = 'A007',
  A265 = 'A265',
  A275 = 'A275',
  A008 = 'A008',
  A258 = 'A258',
  A120 = 'A120',
  A244 = 'A244',
  A240 = 'A240',
  A009 = 'A009',
  A010 = 'A010',
  A012 = 'A012',
  A013 = 'A013',
  A259 = 'A259',
  A241 = 'A241',
  A260 = 'A260',
  A261 = 'A261',
  A262 = 'A262',
  A190 = 'A190',
  A014 = 'A014',
  A015 = 'A015',
  A016 = 'A016',
  A017 = 'A017',
  A018 = 'A018',
  A019 = 'A019',
  A020 = 'A020',
  A021 = 'A021',
  A022 = 'A022',
  A023 = 'A023',
  A024 = 'A024',
  A025 = 'A025',
  A026 = 'A026',
  A027 = 'A027',
  A028 = 'A028',
  A029 = 'A029',
  A030 = 'A030',
  A031 = 'A031',
  A032 = 'A032',
  A267 = 'A267',
  A033 = 'A033',
  A034 = 'A034',
  A035 = 'A035',
  A036 = 'A036',
  A037 = 'A037',
  A038 = 'A038',
  A039 = 'A039',
  A040 = 'A040',
  A041 = 'A041',
  A042 = 'A042',
  A043 = 'A043',
  A044 = 'A044',
  A046 = 'A046',
  A048 = 'A048',
  A050 = 'A050',
  A051 = 'A051',
  A054 = 'A054',
  A055 = 'A055',
  A056 = 'A056',
  A057 = 'A057',
  A058 = 'A058',
  A059 = 'A059',
  A060 = 'A060',
  A061 = 'A061',
  A062 = 'A062',
  A064 = 'A064',
  A065 = 'A065',
  A066 = 'A066',
  A068 = 'A068',
  A069 = 'A069',
  A070 = 'A070',
  A071 = 'A071',
  A072 = 'A072',
  A073 = 'A073',
  A074 = 'A074',
  A075 = 'A075',
  A076 = 'A076',
  A077 = 'A077',
  A078 = 'A078',
  A079 = 'A079',
  A080 = 'A080',
  A081 = 'A081',
  A082 = 'A082',
  A083 = 'A083',
  A084 = 'A084',
  A085 = 'A085',
  A086 = 'A086',
  A087 = 'A087',
  A088 = 'A088',
  A089 = 'A089',
  A091 = 'A091',
  A092 = 'A092',
  A093 = 'A093',
  A094 = 'A094',
  A095 = 'A095',
  A096 = 'A096',
  A097 = 'A097',
  A098 = 'A098',
  A099 = 'A099',
  A100 = 'A100',
  A101 = 'A101',
  A102 = 'A102',
  A103 = 'A103',
  A104 = 'A104',
  A105 = 'A105',
  A106 = 'A106',
  A107 = 'A107',
  A108 = 'A108',
  A109 = 'A109',
  A110 = 'A110',
  A111 = 'A111',
  A112 = 'A112',
  A113 = 'A113',
  A114 = 'A114',
  A115 = 'A115',
  A116 = 'A116',
  A119 = 'A119',
  A122 = 'A122',
  A123 = 'A123',
  A124 = 'A124',
  A125 = 'A125',
  A126 = 'A126',
  A128 = 'A128',
  A129 = 'A129',
  A130 = 'A130',
  A131 = 'A131',
  A132 = 'A132',
  A133 = 'A133',
  A134 = 'A134',
  A135 = 'A135',
  A136 = 'A136',
  A137 = 'A137',
  A138 = 'A138',
  A139 = 'A139',
  A140 = 'A140',
  A141 = 'A141',
  A142 = 'A142',
  A143 = 'A143',
  A145 = 'A145',
  A146 = 'A146',
  A147 = 'A147',
  A148 = 'A148',
  A149 = 'A149',
  A150 = 'A150',
  A154 = 'A154',
  A156 = 'A156',
  A157 = 'A157',
  A158 = 'A158',
  A159 = 'A159',
  A160 = 'A160',
  A161 = 'A161',
  A162 = 'A162',
  A163 = 'A163',
  A166 = 'A166',
  A171 = 'A171',
  A172 = 'A172',
  A173 = 'A173',
  A174 = 'A174',
  A175 = 'A175',
  A176 = 'A176',
  A177 = 'A177',
  A178 = 'A178',
  A180 = 'A180',
  A182 = 'A182',
  A184 = 'A184',
  A185 = 'A185',
  A187 = 'A187',
  A189 = 'A189',
  A199 = 'A199',
  A203 = 'A203',
  A191 = 'A191',
  A192 = 'A192',
  A193 = 'A193',
  A201 = 'A201',
  A202 = 'A202',
  A204 = 'A204',
  A205 = 'A205',
  A206 = 'A206',
  A207 = 'A207',
  A208 = 'A208',
  A209 = 'A209',
  A210 = 'A210',
  A213 = 'A213',
  A214 = 'A214',
  A218 = 'A218',
  A221 = 'A221',
  A222 = 'A222',
  A223 = 'A223',
  A225 = 'A225',
  A227 = 'A227',
  A232 = 'A232',
  A237 = 'A237',
  A238 = 'A238',
  A239 = 'A239',
  A224 = 'A224',
  A233 = 'A233',
  A228 = 'A228',
  A229 = 'A229',
  A230 = 'A230',
  A231 = 'A231',
  A234 = 'A234',
  A245 = 'A245',
  A236 = 'A236',
  A246 = 'A246',
  A247 = 'A247',
  A248 = 'A248',
  A250 = 'A250',
  A251 = 'A251',
  A254 = 'A254',
  A255 = 'A255',
  A256 = 'A256',
  A257 = 'A257',
  A242 = 'A242',
  A243 = 'A243',
  A220 = 'A220',
  A263 = 'A263',
  A249 = 'A249',
  A266 = 'A266',
  A268 = 'A268',
  A269 = 'A269',
  A270 = 'A270',
  A271 = 'A271',
  A272 = 'A272',
  A273 = 'A273',
  A274 = 'A274',
}
